<template>
    <div ref="content" :class="{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}">
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle">{{$t('order.geren')}}</div>
            <div class="person_info display_flex">
                <div class="headImg" :style="{backgroundImage:'url('+ personInfo.image +')'}"></div>
                <div class="info_detail">
                    <div class="nickname">{{personInfo.nickname}}</div>
                    <div><span class="info_left">{{$t('personal.sex')}}</span>{{sexdata[personInfo.sex]}}</div>
                    <div><span class="info_left">{{$t('personal.phone')}}</span>{{personInfo.mobile}}</div>
                    <div><span class="info_left">{{$t('personal.address')}}</span>{{personInfo.address}}</div>
                </div>
                <div class="edit_btn" @click="gorouter('modifyInfo')">{{$t('personal.edit')}}</div>
            </div>
            <div v-if="rank_boughtlist.length >0 || report_boughtlist.length > 0" class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify"><span>{{$t('personal.myshoppingcart')}}</span><span class="lookall" @click="gorouter('/bought')">{{$t('order.morebought')}}</span></div>

            <div v-if="rank_boughtlist.length >0">
                <div class="cartbox  padding_left_24">{{$t('rankindex.menu1_rank')}}</div>
                    <div class="padding_top_32 textalign_left">
                        <div class="rankitem" v-for="(val,index) in rank_boughtlist" @click="torankdetail(val)" :key="index">
                            <div class="coveritem" :style="{backgroundImage: 'url(' +  val.listImage+ ')'}">
                            </div>
                            <div class="sec_name">{{val.title}}</div>
                            <div class="date display_flex justify-content_flex-justify">
                                <div>{{formatTimefun(val.publishTime)}}</div>
                                <img src="../../assets/images/rang.png" width="16" height="16">
                            </div>
                        </div>
                    </div>
            </div>
            <div v-if="report_boughtlist.length > 0  && currentlang !=='eng'">
                <div class="cartbox  padding_left_24 margin_top_40">{{$t('common.reportName')}}</div>
                <div class="padding_top_32">
                    <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;"  v-for="(item,index) in report_boughtlist" @click="toreportdetail(item)">
                        <div class="rank_reportL">
                            <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                            <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                                <div>
                                    <div class="title_limit2 line2">{{item.title}}</div>
                                    <div class="report_content">{{item.summary}}</div>
                                </div>
                                <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                            </div>
                        </div>
                        <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePc +')'}"></div>
                    </div>
                </div>
            </div>
            <div v-if="orderdata.length >0">
                <div class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify"><span>{{$t('personal.myorder')}}</span><span class="lookall" @click="gorouter('myorder')">{{$t('order.moreorder')}}</span></div>
                <div class="cartbox display_flex">
                    <span class="width_562 padding_left_280">{{$t('order.orderproduct')}}</span>
                    <span class="width_203 textalign_center">{{$t('order.ordermoney')}}</span>
                    <span class="width_203 textalign_center">{{$t('order.orderstatus')}}</span>
                    <span class="width_203 textalign_center">{{$t('order.orderocaozuo')}}</span>
                </div>
                <div>
                    <div v-for="item in orderdata">
                        <div class="person_order_box padding_left_24 margin_top_32 display_flex  justify-content_flex-justify">
                            <div><span>{{$t('personal.orderNo')}}:{{item.orderNo}}</span> <span class="padding_left_32">{{$t('order.order_creattime')}}：{{formatTimefun(item.ctime)}}</span></div>
                            <!-- <div class="padding_right_16">删除</div> -->
                        </div>
                        <div class="cartlist" >
                            <div class=" display_flex  justify-content_flex-justify align-items_center">
                                <table class="person_cartlist_Item_R display_flex align-items_center">
                                    <tr>
                                        <td class="width_562">
                                            <div class="person_order_Each " v-for="val in item.prdList">
                                                <div class="roundType">{{rank_type[val.prdType]}}</div>
                                                <div class="carttitle">
                                                    {{val.title}}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="width_203 red">¥ {{item.totalPrice}}</td>
                                        <td class="width_203">{{orderstatus[item.status]}}</td>
                                        <td class="width_203">
                                            <div v-if="item.status == 0 " class="payButton" @click="payagain(item)">
                                                {{$t('personal.paynow')}}
                                            </div>
                                            <span class="cursor_p" @click="gorouter('/orderdetail?orderNo='+item.orderNo)">{{$t('order.ordertail')}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify" v-if="myrankdata.total >0 || myreportdata.total >0 || myproductdata.total >0 "><span>{{$t('personal.mycollection')}}</span><span class="lookall" @click="gorouter('/myCollection?type=rank')">{{$t('order.morecollection')}}</span></div>
            <div v-if="myrankdata.list.length >0">
                <div class="cartbox  padding_left_24  padding_right_28 display_flex  justify-content_flex-justify"><span>{{$t('common.rankName')}} {{myrankdata.total}}{{$t('rankindex.Num')}}</span><span class="cursor_p" @click="gorouter('/myCollection?type=rank')">{{$t('index.more')}}</span></div>
                <div class="position_relative display_flex   flex-wrap_wrap padding_top_32">
                    <div class="rankitem" v-for="item in myrankdata.list" @click="todetail('rank',item)">
                        <div class="coveritem" :style="{backgroundImage:'url('+ item.listImage +')'}">
                            
                        </div>
                        <div class="sec_name">{{item.title}}</div>
                        <div class="date display_flex justify-content_flex-justify">
                            <div>{{formatTimefun(item.publishTime)}}</div>
                            <img src="../../assets/images/rang.png" width="16" height="16">
                        </div>
                        <div class="buystatus display_flex" v-if="!item.buyStatus">
                            <div class="flex_1 addrank" @click="todetail('rank',item)">{{$t('modal.addcart')}}</div>
                            <div class="flex_1 buyrank" @click="todetail('rank',item)">{{$t('modal.buynow')}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="myreportdata.list.length >0 &&  currentlang !=='eng'">
                <div class="cartbox  padding_left_24  padding_right_28 display_flex  justify-content_flex-justify margin_top_40 margin_bottom_32"><span>{{$t('common.reportName')}} {{myreportdata.total}}{{$t('rankindex.Num')}}</span><span class="cursor_p" @click="gorouter('/myCollection?type=report')">{{$t('index.more')}}</span></div>
                <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;"  v-for="item in myreportdata.list" @click="todetail('report',item)">
                    <div class="rank_reportL">
                        <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                        <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                            <div>
                                <div class="title_limit2 line2">{{item.title}}</div>
                                <div class="report_content">{{item.summary}}</div>
                            </div>
                            <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                        </div>
                    </div>
                    <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePc +')'}"></div>
                    <div class="report_buystatus display_flex" v-if="!item.buyStatus">
                        <div class="flex_1 addrank" @click="todetail('report',item)">{{$t('modal.addcart')}}</div>
                        <div class="flex_1 buyrank" @click="todetail('report',item)">{{$t('modal.buynow')}}</div>
                    </div>
                </div>
            </div>
            <div v-if="myproductdata.list.length >0">
                <div class="cartbox  padding_left_24  padding_right_28 display_flex  justify-content_flex-justify margin_top_40 margin_bottom_32"><span>{{$t('common.productName')}} {{myproductdata.total}}{{$t('rankindex.Num')}}</span><span class="cursor_p" @click="gorouter('/myCollection?type=product')">{{$t('index.more')}}</span></div>
                <div class="display_flex   flex-wrap_wrap padding_bottom_104">
                    <div v-for="item in myproductdata.list"  :class="['product_item',{'eng':currentlang == 'eng'}]" @click="toproductdetail(item)">
                        <div class="labelImg">
                            <img :src="labelarr['green']" alt="" v-if="Number(item.fishClass) == 10">
                            <img :src="labelarr['effect']" alt="" v-if="Number(item.efficacyAntiacne) || Number(item.efficacyAntiaging) || Number(item.efficacyMoisturizing) || Number(item.efficacyRepair) || Number(item.efficacyWhitening)">
                        </div>
                        <div class="productImg" :style="{backgroundImage:'url('+ item.img +')'}">
                            <!-- <img src="http://p1.fishqc.net/FjBvluNRlXgj6H6crSHeApGPtljD!product.thumb"> -->
                        </div>
                        <div class="padding_bottom_16">
                            <div class="limit2">{{item.prdName}}</div>
                        </div>
                        
                       <!--  <div class="productInfo display_flex justify-content_flex-justify">
                            <span>{{$t('product.price')}}:<span class="main">{{item.price}} {{item.currency}}</span></span>
                            <span>{{$t('index.address')}}:<span class="main">{{item.originplace}}</span></span>
                        </div> -->

                        <div class="productInfo display_flex justify-content_flex-justify" v-if="currentlang !== 'eng'">
                            <span>{{$t('product.price')}}：<span class="main">{{item.price}}{{item.currency}}</span></span>
                            <span>{{$t('product.address')}}：<span class="main">{{item.originplace}}</span></span>
                        </div>
                        <div v-if="currentlang == 'eng'">
                            <div class="productInfo display_flex justify-content_flex-justify">
                                <span class="flex_1">{{$t('product.price')}}：</span>
                                <span class="flex_1">{{$t('product.address')}}：</span>
                            </div>
                            <div class="productInfo display_flex justify-content_flex-justify" style="padding-top: 8px;">
                                <span class="flex_1 main">{{item.price}}{{item.currency}}</span>
                                <span class="flex_1 main">{{item.originplace}}</span>
                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}


// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

    .lookall {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262633;
        padding-right: 12px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        &:after{
            content:'';
            position: absolute;
            right:0;
            top:13px;
            width:6px;
            height: 6px;
            border-top:1px solid #262633;
            border-right:1px solid #262633;
            transform: rotate(45deg);

        }
    }
}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32 {
    margin-top: 32px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32{
    margin-bottom:32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}
.padding_right_28{
    padding-right:28px;
    box-sizing: border-box;
}
.icon_round {
    width: 24px;
    height: 24px;
    border: 1px solid #D5D5D7;
    border-radius: 50%;
}

.cartbox {
    height: 64px;
    line-height: 64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;
    padding-left: 24px;
    box-sizing: border-box;
    .totalprice {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }

    .paybtn {
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
    }
}

.cartlist {

    .cartlist_Item {
        margin-top: 24px;

    }
    .person_cartlist_Item_R {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #F4F4F5;
        padding: 24px 0 24px 24px;
        box-sizing: border-box;
        
        .person_order_Each{
            padding-bottom: 24px;
            box-sizing: border-box;
            &:last-child{
                padding-bottom: 0;
            }
        }
        .width_203{
            width:203px;
            font-size: 16px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: #51515C;
            line-height: 16px;
            text-align: center;
            border-left:1px solid #F4F4F5;
            box-sizing: border-box;
            &.red{
                color: #FF7467;
            }
        }

        .roundType {
            width: 72px;
            height: 72px;
            line-height: 72px;
            color: #fff;
            border-radius: 50%;
            background-color: #60DEB4;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            text-align: center;
            display: inline-block;
            vertical-align: middle;
        }

        .carttitle {
            width: 385px;
            margin-right:  80px;
            margin-left: 24px;
            text-align: left;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #262633;
            line-height: 36px;
            @include linelimt(1);
            display: inline-block;
            vertical-align: middle;
            .title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #262633;
                line-height: 36px;
                @include linelimt(1);
            }

            .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 24px;
                @include linelimt(1);
                margin-top: 4px;
            }
        }

        .price {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7467;
            padding-left: 78px;
            box-sizing: border-box;
        }

        .delbtn {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            text-align: center;
        }
    }
    // .person_cartlist_Item_R {
    //     width: 100%;
    //     background: #FFFFFF;
    //     border: 1px solid #F4F4F5;
    //     padding: 24px 0 24px 24px;
    //     box-sizing: border-box;
    //     .person_order_Each{
    //         padding-bottom: 24px;
    //         box-sizing: border-box;
    //     }

    //     .roundType {
    //         width: 72px;
    //         height: 72px;
    //         line-height: 72px;
    //         color: #fff;
    //         border-radius: 50%;
    //         background-color: #60DEB4;
    //         font-size: 24px;
    //         font-family: PingFangSC-Medium, PingFang SC;
    //         font-weight: 500;
    //     }

    //     .carttitle {
    //         width: 385px;
    //         margin-right:  80px;
    //         margin-left: 24px;
    //         text-align: left;

    //         .title {
    //             font-size: 24px;
    //             font-family: PingFangSC-Medium, PingFang SC;
    //             font-weight: 500;
    //             color: #262633;
    //             line-height: 36px;
    //             @include linelimt(1);
    //         }

    //         .desc {
    //             font-size: 14px;
    //             font-family: PingFangSC-Regular, PingFang SC;
    //             font-weight: 400;
    //             color: #888888;
    //             line-height: 24px;
    //             @include linelimt(1);
    //             margin-top: 4px;
    //         }
    //     }

    //     .price {
    //         font-size: 18px;
    //         font-family: PingFangSC-Regular, PingFang SC;
    //         font-weight: 400;
    //         color: #FF7467;
    //         padding-left: 60px;
    //         box-sizing: border-box;
    //     }

    //     .delbtn {
    //         font-size: 14px;
    //         font-family: PingFangSC-Regular, PingFang SC;
    //         font-weight: 400;
    //         color: #51515C;
    //     }
    // }
}

// {{$t('rankindex.Num')}}人中心
.person_info {
    width: 100%;
    height: 240px;
    position: relative;
    // background: #F8FBFD;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('http://p1.fishqc.net/Fpc_RMpTmvHH5uenghghQJDruILD');
    padding: 64px 0 0 64px;
    box-sizing: border-box;

    .headImg {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #fff;
        margin-right: 60px;
        background: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

    }

    .edit_btn {
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #60DEB4;
        position: absolute;
        right: 32px;
        top: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60DEB4;
        cursor: pointer;

    }

    .info_detail {
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;

        .nickname {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #51515C;
            line-height: 28px;
            padding-bottom: 10px;
            box-sizing: border-box;
        }

        .info_left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8A8AD;
            line-height: 28px;
            padding-right: 16px;
            box-sizing: border-box;
        }

        .info_right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 28px;
        }
    }
}

.person_order_box {
    height: 40px;
    line-height: 40px;
    background: #F8FBFD;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
}

.width_562{
    width: 562px;
}

.width_610{
    width: 610px;
}
.width_203{
    width:203px;
}

.payButton{
    width: 144px;
    height: 36px;
    line-height:36px;
    text-align: center;
    background: #60DEB4;
    border-radius: 18px;
    font-size: 16px;
    font-family: 'PingFang SC';
    font-weight: 500;
    color: #FFFFFF;
    margin:0 auto 16px;
    cursor: pointer;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src 
import banner from '@/components/banner.vue'
import {myMixin} from '@/mixin/mixin.js'
import { orderlistlApi,collectlistApi,buylistApi,personinfoApi} from '@/api/api.js'
import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
export default {  
    name: '',
    components: {
        banner,
        modal:Modal
    },
    mixins:[myMixin], 
    data() {
        return {
           currenttap: 'myrank',
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination1'
                },
                uniqueNavElements: false,

                // Some Swiper option/callback...
            },
            orderdata:{},
            myrankdata:{
                list:[]
            },
            myreportdata:{
                list:[]
            },
            myproductdata:{
                list:[]
            },
            report_boughtlist:[],
            rank_boughtlist:[],
            personInfo:{},
            currentlang:'',
            sexdata:{
                '0':'保密',
                '1':this.$t('personal.man'),
                '2':this.$t('personal.women')

            },
            ismodalshow:false

        }
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y-M-D h:m')
            }
        }
    },
    watch:{
        'personInfo':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'rank_boughtlist':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'report_boughtlist':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'orderdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'myrankdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'myreportdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        'myproductdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        }
    },
    mounted() {
        this.currentlang = window.localStorage.getItem("LOCALE")
        this.orderlist()
        this.colloctlist('12')
        this.colloctlist('13')
        this.colloctlist('1456')
        this.myboughtlist('1')
        this.myboughtlist('2')
        this.personinfofun() 
    },
    methods: {
        tapchoose(item) {
            this.currenttap = item
        },
        orderlist(){
            orderlistlApi({
                page: this.currentpage,
                limit:6,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.orderdata = res.data.result
                } else {
                    // this.toast(res.message)
                    

                }
            })
        },
        // 二次支付入口  
        payagain(item){
            window.sessionStorage.setItem('orderlist',JSON.stringify(item.prdList));
            this.$router.push({
                path:'/pay',
                query:{
                    paytype:2,  //再次支付标识
                    orderNo:item.orderNo,
                    totalPrice:item.totalPrice

                }
            })
            
        },
        // 我的收藏   
        colloctlist(type){
            collectlistApi({
                favtype:type,
                page: this.currentpage,
                limit:8,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    if(type == 12){
                        this.myrankdata = res.data 
                    }

                    if(type == 13){
                        this.myreportdata = res.data 
                    }

                    if(type == 1456){
                        this.myproductdata = res.data
                    }
                    
                }else {
                    // this.toast(res.message)
                    

                }
            })
        },    
        // 我的已购
        myboughtlist(type){
            buylistApi({
                prdType:type,
                page: this.currentpage,
                limit:4,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    console.log('已购',res.data)
                    if(type == 1){
                        this.rank_boughtlist = res.data.prdList
                    }
                    if(type == 2){
                        this.report_boughtlist = res.data.prdList
                    }
                    // this.boughtlist = res.data.prdList
                }else if(res.code == 401){
                    // this.gorouter('/login?region=0')
                }else {
                    // this.toast(res.message)
                    

                }
            })
        },
        personinfofun(){
            personinfoApi({}).then(res => {

                if (res.code == 200) {
                    this.personInfo = res.data
                }else if(res.code == 401){

                }else {
                    // this.toast(res.message)
                    
                }
            })

        },
        todetail(type,item){
            
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.prdUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    if(item.buyStatus){  //已购买榜单，进入详情
                        this.gorouter('/rank/detail/'+item.prdUnionId)
                    }else{
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',
                            itemtype:'1',    //榜单
                            itemdata:item
                        });
                    }
                break;
            }
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
        torankdetail(item){
            this.gorouter('/rank/detail/'+item.prdId)
        },
        toreportdetail(item){
            this.gorouter('/report/detail/'+item.prdId)
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
    }
}
</script>